module.exports = __webpack_public_path__ + "static/media/career.fb38c384.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/career.svg
// module id = 1840
// module chunks = 2